var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Test multi")]),_vm._v(" "),_c('p',[_vm._v("router links naar componenten")]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"lightgray"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }